import { createRouter, createWebHistory } from 'vue-router';
import store from '../store';
/* Layout */
import Layout from '@/layout';
import { require } from '@/utils/index';

const centerRoutes_chinese = [
    //服务协议和隐私政策
    {
      path: '/chService',
      name: '服务协议',
      component: () => import('@/views/servicePolicy/chService.vue'),
      meta: {  }
    },
    {
      path: '/chPolicy',
      name: '隐私政策',
      component: () => import('@/views/servicePolicy/chPolicy.vue'),
      meta: {  }
    },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login.vue'),
    meta: { title: '登录', icon: 'home', hide: true }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/center/register.vue'),
    meta: { title: '注册', icon: 'home', hide: true }
  },
  {
    path: '/resetPassword',
    name: 'ResetPassword',
    component: () => import('@/views/center/resetPassword.vue'),
    meta: { title: '重置密码', icon: 'home', hide: true }
  },
  {
    path: '/confirmPassword',
    name: 'ConfirmPassword',
    component: () => import('@/views/confirmPassword.vue'),
    meta: { title: '确认密码', icon: 'home', hide: true }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    meta: { title: '总览', icon: require('@/assets/images/center/menu.png'), hide: true },
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('@/views/center/dashboard/dashboard.vue')
      },
      {
        path: 'completeOrderWallet',
        name: 'CompleteOrderWallet',
        component: () => import('@/views/completeOrderWallet.vue'),
        meta: {
          title: '余额充值',
          icon: require('@/assets/images/center/menu_rocket_wallet.png'),
          hide: true  // 添加这一行来隐藏菜单项
        }
      },
    ]
  },
  {
    path: '/product',
    component: Layout,
    redirect: '/product/price',
    name: 'Product',
    meta: { title: '基本产品', icon: require('@/assets/images/center/basic.png'), hide: true },
    children: [
      {
        path: 'price',
        name: 'Price',
        component: () => import('@/views/center/product/proxyList.vue'),
        // meta: { title: '住宅代理', icon: require('@/assets/images/center/menu_price.png') }
      },
    ]
  },
  {
    path: '/mobility',
    component: Layout,
    redirect: '/mobility/price',
    name: 'Mobility',
    meta: { title: '移动产品', icon: require('@/assets/images/center/mobility.png'), hide: true },
    children: [
      {
        path: 'price',
        name: 'mobilityPrice',
        component: () => import('@/views/center/mobility/proxyList.vue'),
        // meta: { title: '住宅代理', icon: require('@/assets/images/center/menu_price.png') }
      },
    ]
  },
  {
    path: '/infinite',
    component: Layout,
    redirect: '/Infinite/InfinitePlans',
    name: 'Infinite',
    meta: { title: '无限产品', icon: require('@/assets/images/center/infinite.png') },
    children: [
      {
        path: 'infinitePrice',
        name: 'InfinitePrice',
        component: () => import('@/views/center/infinite/infinitePrice.vue'),
        meta: { title: '无限代理' }
      },
      {
        path: 'infinitePlans',
        name: 'InfinitePlans',
        component: () => import('@/views/center/infinite/infinitePlans.vue'),
        meta: { title: '无限详情' }
      },
      {
        path: 'completeOrderInfinite',
        name: 'CompleteOrderInfinite',
        component: () => import('@/views/completeOrderInfinite.vue'),
        meta: { 
            hide: true  ,// 添加这一行来隐藏菜单项
            title: '完成订单' ,
        }
      }
    ]
  },
  {
    path: '/staticState',
    component: Layout,
    redirect: '/staticState/staticPrice',
    name: 'StaticState',
    meta: { title: '静态产品', icon: require('@/assets/images/center/static.png'), hide: true },
    children: [
      {
        path: 'staticPrice',
        name: 'StaticPrice',
        component: () => import('@/views/center/staticState/staticList.vue'),
      },
      {
        path: 'completeOrderstatic',
        name: 'CompleteOrderstatic',
        component: () => import('@/views/completeOrderstatic.vue'),  
        meta: {
          title: '结算订单',
          icon: require('@/assets/images/center/menu_rocket_wallet.png'),
          hide: true  // 添加这一行来隐藏菜单项
        }
      }
    ]
  },
  {
    path: '/quickStart',
    component: Layout,
    redirect: '/quickStart',
    meta: { title: '简介', icon: require('@/assets/images/center/quickStart.png'), hide: true },
    children: [
      {
        path: '/quickStart',
        name: 'quickStart',
        component: () => import('@/views/center/quickStart/quickStart.vue'),
      },
    ]
  },
  {
    path: '/account',
    component: Layout,
    redirect: '/account/profile',
    name: 'Account',
    meta: { title: '账号', icon: require('@/assets/images/center/profile_avatar.png') },
    children: [
      {
        path: 'profile',
        name: 'Profile',
        component: () => import('@/views/center/account/profile.vue'),
        meta: { title: '账号信息', icon: require('@/assets/images/center/profile.png') }
      },
      {
        path: 'billings',
        name: 'Billings',
        component: () => import('@/views/center/account/billings.vue'),
        meta: { title: '账单详情', icon: require('@/assets/images/center/menu_billings.png') }
      },
      {
        path: 'Union',
        name: 'Union',
        component: () => import('@/views/center/account/Union.vue'),
        meta: { title: '计划明细', icon: require('@/assets/images/center/menu_billings.png') }
      },
    ]
  },
  {
    path: '/helpCenter',
    name: 'HelpCenter',
    component: Layout,
    redirect: '/helpCenter/index',
    meta: { title: '了解更多', icon: require('@/assets/images/center/bang_zhu.png') },
    children: [
      {
        path: 'guide',
        name: 'HelpCenterGuide',
        component: () => import('@/views/center/helpCenter/guide.vue'),
        meta: { title: '新手指南' }
      },
      {
        path: 'index',
        name: 'HelpCenterIndex',
        component: () => import('@/views/center/helpCenter/index.vue'),
        meta: { title: '入门教程' }
      },
      {
        path: 'faq',
        name: 'HelpCenterFAQ',
        component: () => import('@/views/center/helpCenter/faq.vue'),
        meta: { title: '问题解答' }
      }
    ]
  }
];
const centerRoutes_english = [
  {
    path: '/enService',
    name: 'Service Terms',
    component: () => import('@/views/servicePolicy/enService.vue'),
    meta: {hide: true}
  },
  {
    path: '/enPolicy',
    name: 'Privacy Policy',
    component: () => import('@/views/servicePolicy/enPolicy.vue'),
    meta: {hide: true}
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login.vue'),
    meta: { title: 'Login', icon: 'home', hide: true }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/center/register.vue'),
    meta: { title: 'Register', icon: 'home', hide: true }
  },
  {
    path: '/resetPassword',
    name: 'ResetPassword',
    component: () => import('@/views/center/resetPassword.vue'),
    meta: { title: 'Reset password', icon: 'home', hide: true }
  },
  {
    path: '/confirmPassword',
    name: 'ConfirmPassword',
    component: () => import('@/views/confirmPassword.vue'),
    meta: { title: 'Confirm password', icon: 'home', hide: true }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    meta: { title: 'Overview', icon: require('@/assets/images/center/menu.png'), hide: true },
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('@/views/center/dashboard/dashboard.vue')
      },
      {
        path: 'completeOrderWallet',
        name: 'CompleteOrderWallet',
        component: () => import('@/views/completeOrderWallet.vue'),
        meta: {
          title: 'balance recharge',
          icon: require('@/assets/images/center/menu_rocket_wallet.png'),
          hide: true  // 添加这一行来隐藏菜单项
        }
      },
    ]
  },
  {
    path: '/product',
    component: Layout,
    redirect: '/product/price',
    name: 'Product',
    meta: { title: 'Basic Proxy', icon: require('@/assets/images/center/basic.png'), hide: true },
    children: [
      {
        path: 'price',
        name: 'Price',
        component: () => import('@/views/center/product/proxyList.vue'),
        // meta: { title: 'Price', icon: require('@/assets/images/center/menu_price.png') }
      },
    ]
  },
  {
    path: '/mobility',
    component: Layout,
    redirect: '/mobility/price',
    name: 'Mobility',
    meta: { title: 'Mobility Proxy', icon: require('@/assets/images/center/mobility.png'), hide: true },
    children: [
      {
        path: 'price',
        name: 'mobilityPrice',
        component: () => import('@/views/center/mobility/proxyList.vue'),
        // meta: { title: '住宅代理', icon: require('@/assets/images/center/menu_price.png') }
      },
    ]
  },
  {
    path: '/Infinite',
    component: Layout,
    redirect: '/Infinite/InfinitePlans',
    name: 'Infinite',
    meta: { title: 'Infinite Product', icon: require('@/assets/images/center/infinite.png') },
    children: [
      {
        path: 'infinitePrice',
        name: 'InfinitePrice',
        component: () => import('@/views/center/infinite/infinitePrice.vue'),
        meta: { title: 'Infinite Proxy' }
      },
      {
        path: 'infinitePlans',
        name: 'InfinitePlans',
        component: () => import('@/views/center/infinite/infinitePlans.vue'),
        meta: { title: 'Infinite Details' }
      },
      {
        path: 'completeOrderInfinite',
        name: 'CompleteOrderInfinite',
        component: () => import('@/views/completeOrderInfinite.vue'),
        meta: { 
            hide: true  ,// 添加这一行来隐藏菜单项
            title: 'Complete order',
        }
      }
    ]
  },
  {
    path: '/staticState',
    component: Layout,
    redirect: '/staticState/staticPrice',
    name: 'StaticState',
    meta: { title: 'Static Product', icon: require('@/assets/images/center/static.png'), hide: true },
    children: [
      {
        path: 'staticPrice',
        name: 'StaticPrice',
        component: () => import('@/views/center/staticState/staticList.vue'),
      },
      {
        path: 'completeOrderstatic',
        name: 'CompleteOrderstatic',
        component: () => import('@/views/completeOrderstatic.vue'),  
        meta: {
          title: 'completeOrder Static',
          icon: require('@/assets/images/center/menu_rocket_wallet.png'),
          hide: true  // 添加这一行来隐藏菜单项
        }
      }
    ]
  },
  {
    path: '/quickStart',
    component: Layout,
    redirect: '/quickStart',
    meta: { title: 'Introduction', icon: require('@/assets/images/center/quickStart.png'), hide: true },
    children: [
      {
        path: '/quickStart',
        name: 'quickStart',
        component: () => import('@/views/center/quickStart/quickStart.vue'),
      },
    ]
  },
  {
    path: '/account',
    component: Layout,
    redirect: '/account/profile',
    name: 'Account',
    meta: { title: 'Account', icon: require('@/assets/images/center/profile_avatar.png') },
    children: [
      {
        path: 'profile',
        name: 'Profile',
        component: () => import('@/views/center/account/profile.vue'),
        meta: { title: 'Profile', icon: require('@/assets/images/center/profile.png') }
      },
      {
        path: 'billings',
        name: 'Billings',
        component: () => import('@/views/center/account/billings.vue'),
        meta: { title: 'Detailed Bill', icon: require('@/assets/images/center/menu_billings.png') }
      },
      {
        path: 'Union',
        name: 'Union',
        component: () => import('@/views/center/account/Union.vue'),
        meta: { title: 'Plan Details', icon: require('@/assets/images/center/menu_billings.png') }
      },
    ]
  },
  {
    path: '/helpCenter',
    name: 'HelpCenter',
    component: Layout,
    redirect: '/helpCenter/index',
    meta: { title: 'LearnMore', icon: require('@/assets/images/center/bang_zhu.png') },
    children: [
      {
        path: 'guide',
        name: 'HelpCenterGuide',
        component: () => import('@/views/center/helpCenter/guide.vue'),
        meta: { title: 'Started Guide' }
      },
      {
        path: 'index',
        name: 'HelpCenterIndex',
        component: () => import('@/views/center/helpCenter/index.vue'),
        meta: { title: 'Tutorial Document' }
      },
      {
        path: 'faq',
        name: 'HelpCenterFAQ',
        component: () => import('@/views/center/helpCenter/faq.vue'),
        meta: { title: 'Product FAQ' }
      }
    ]
  }
];
const urlParams = new URLSearchParams(window.location.search);
const langParam = urlParams.get('lang');

// 根据查询参数设置 localStorage 中的语言
if (langParam === 'zh') {
  localStorage.setItem('langrage', 'chinese');
} else if (langParam === 'en') {
  localStorage.setItem('langrage', 'english'); // 默认语言
} else {
}



const lang = localStorage.getItem('langrage');
let centerRoutes = [];
if (lang === 'chinese') {
  centerRoutes = centerRoutes_chinese;
} else if (lang === 'english') {
  centerRoutes = centerRoutes_english;
} else {
  localStorage.setItem('langrage', 'english');
  centerRoutes = centerRoutes_english;
}
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: centerRoutes
});
//校验当前登录的token和user数据,没有就做相应操作
router.beforeEach(async (to, from, next) => {
  let token = localStorage.getItem('token');
  let routs = ['/register', '/Register', '/login', '/resetPassword', '/confirmPassword','/chService','/enService','/chPolicy','/enPolicy'];
  if (routs.indexOf(to.path) >= 0) {
    next();
  }
  else if (token) {
    if (!store.state.user.userInfo) {
      if (to.path === '/dashboard' || to.path === '/') {
        store.dispatch('user/getInfo').catch(() => {
          if (!localStorage.getItem('token')) router.replace('/login');
        });
      } else {
        await store.dispatch('user/getInfo');
      }
    } else if (!from.matched.length) {
      store.dispatch('user/getInfo').catch(() => {});
    }
    next();
  } else {
    next(next('/login'));
  }
});
export default router;
